import publicApiClient from '../clients/publicApiClient';
import { API_ENDPOINTS } from '../endpoints';

export const currenciesApi = {
  getAll() {
    return publicApiClient.get(API_ENDPOINTS.currencies.getAll);
  },
};
